import { useState, useRef, useEffect } from 'react';
import { searchGuest } from '../utils/helperFunctions';

const MobileNumberDropdown = ({ formData, formErrors, handleChange, handleSuggestionClick, suggestions, loading,setSuggestions,setLoading,query}) => {
    // const dropdownRef = useRef(null);
    const suggestionsRef = useRef(null);
    const [isMobileInputFocused, setIsMobileInputFocused] = useState(false);   
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const handleKeyDown = (e) => {
        // console.log(e.key);
        
        if (!isMobileInputFocused || suggestions.length === 0) return;
        e.stopPropagation();
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            const newIndex = selectedIndex < suggestions.length - 1 ? selectedIndex + 1 : selectedIndex;
            setSelectedIndex(newIndex);
            scrollIntoView(newIndex);
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            const newIndex = selectedIndex > 0 ? selectedIndex - 1 : -1;
            setSelectedIndex(newIndex);
            if (newIndex >= 0) scrollIntoView(newIndex);
        } else if ((e.key === 'Enter') && selectedIndex >= 0) {
            e.preventDefault();
            handleSuggestionClick(suggestions[selectedIndex]);
            setIsMobileInputFocused(false);
            setSelectedIndex(-1);
        } else if (e.key === 'Escape') {
            e.preventDefault();
            if (selectedIndex >= 0) {
                handleSuggestionClick(suggestions[selectedIndex]);
            }
            setIsMobileInputFocused(false);
            setSelectedIndex(-1);
        }
    };

    const scrollIntoView = (index) => {
        if (suggestionsRef.current && suggestionsRef.current.children[index]) {
            suggestionsRef.current.children[index].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
            });
        }
    };

    const handleInputChange = (e) => {
        handleChange(e); 
        if (!isMobileInputFocused) {
            setIsMobileInputFocused(true); 
        }
    };

    useEffect(() => {
        if (!isMobileInputFocused) {
            setSelectedIndex(-1);
        }
    }, [isMobileInputFocused]);

    useEffect(() => {
        if (formData.mobileNumber.length < 4) {
          setSuggestions([]);
          return;
        }
        if (query.trim()) {
          const delayDebounceFn = setTimeout(async () => {
            try {
              setLoading(true);
              const response = await searchGuest(query);
              if (response.data.status) {
                setSuggestions(response.data.data);
              }
            } catch (error) {
              console.error("Error fetching suggestions", error);
            } finally {
              setLoading(false);
            }
          }, 500);
          return () => clearTimeout(delayDebounceFn);
        }
      }, [query]);

    return (
        <div className="relative col-span-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">Mobile Number*</label>
            <div className="relative" >
                <input
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    name="mobileNumber"
                    value={formData.mobileNumber}
                    onChange={handleInputChange}
                    onFocus={() => setIsMobileInputFocused(true)}
                    onBlur={() => setTimeout(() => setIsMobileInputFocused(false), 200)}
                    onKeyDown={handleKeyDown}
                    pattern="[0-9]{10}"
                    // maxLength="10"
                    inputMode="numeric"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    keydata="mobile_no"
                    required
                    autoComplete="off"
                />
                {loading && (
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                        <svg className="animate-spin h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    </div>
                )}
                {formErrors.mobileNumber && (
                    <p className="mt-1 text-sm text-red-600">{formErrors.mobileNumber}</p>
                )}
                {suggestions.length > 0 && isMobileInputFocused && (
                    <div className="absolute z-50 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto" ref={suggestionsRef} >
                        {suggestions.map((data, index) => (
                            <div
                                key={index}
                                onMouseDown={() => handleSuggestionClick(data)}
                                className={`px-4 py-2 text-sm text-gray-700 hover:bg-indigo-50 cursor-pointer border-b border-gray-100 last:border-b-0 ${index === selectedIndex ? 'bg-indigo-50' : ''
                                    }`}
                            >
                                {data.MobileNo} - {data.FirstName}
                                {data.otherGuests?.length > 0 ? ` - ${data.otherGuests[0].fullName}` : ""}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default MobileNumberDropdown;
